module.exports = __webpack_public_path__ + "static/media/feast.9f322db2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/feast.jpg
// module id = 230
// module chunks = 0